import { t } from 'i18next';
import { CollectionOpts, CollectionOrderDirection } from 'json-api-hooks';
import React, { FC } from 'react';

import Collection from '../../../components/./Collection/Collection';
import CollectionItems from '../../../components/./Collection/CollectionItems';
import CollectionPagination from '../../../components/./Collection/CollectionPagination';
import Container from '../../../components/Container';
import { LoadingCard } from '../../../components/Loading';
import PageHeader from '../../../components/PageHeader';
import PageHeaderCard from '../../../components/PageHeader/PageHeaderCard';
import { useCurrentActor } from '../../../hooks/useCurrentActor';
import { appName } from '../../../lib/config';
import EventCard from '../../../models/events/EventCard';
import { Size } from '../../../theme/types';

import glapp from './images/events/glapp.png';

const covers = {
  glapp,
} as Record<string, string>;

const getCollectionFilter = (postalDigits?: number): CollectionOpts<'events'> => {
  if (postalDigits) {
    return {
      filter: { future: ['true'], postalDigits: [postalDigits.toString()] },
      order: { distance: CollectionOrderDirection.Asc, happensAt: CollectionOrderDirection.Asc },
    };
  }

  return { filter: { future: ['true'] } };
};

const EventsPage: FC = () => {
  const { postalDigits } = useCurrentActor();

  return (
    <React.Fragment>
      <PageHeader background={covers[appName]} positionY={37}>
        <PageHeaderCard text={t('pages.events.body')!} title={t('pages.events.label')!} />
      </PageHeader>
      <Container size={Size.Large}>
        <Collection opts={getCollectionFilter(postalDigits)} resourceType="events">
          <CollectionItems<'events'> onLoad={LoadingCard}>
            {(item) => <EventCard item={item} key={item.id} />}
          </CollectionItems>
          <CollectionPagination />
        </Collection>
      </Container>
    </React.Fragment>
  );
};

export default EventsPage;
